import { useGetBackListeElettorali } from '@framework/api-client';
import { SelectInput } from '@framework/form';
import { useMemo } from 'react';
import { electoralListChooserFetchLimit } from '../electoralListChooserMembers';

export interface IElectoralListOrderInputProps {
  name: string;
  style?: React.CSSProperties;
}

/**
 * Multi-select controllato legato a `electoralListIds: string[]`.
 * L'ordine di selezione è preservato (l'array value di antd Select
 * mode="multiple" mantiene l'ordine di inserimento).
 */
export function ElectoralListOrderInput(props: Readonly<IElectoralListOrderInputProps>) {
  const { name, style } = props;

  const { data: electoralList } = useGetBackListeElettorali({
    isAttiva: true,
    isTornataAttiva: true,
    limite: electoralListChooserFetchLimit,
  });

  const options = useMemo(
    () =>
      electoralList?.dati
        ?.map(item => {
          if (!item.id || !item.nome) return null;
          return { value: item.id, label: item.nome };
        })
        .filter((el): el is { value: string; label: string } => el !== null) ??
      [],
    [electoralList],
  );

  return (
    <SelectInput
      name={name}
      mode="multiple"
      options={options}
      placeholder="Seleziona le liste elettorali..."
      style={{ width: '100%', ...style }}
      optionFilterProp="label"
      showSearch
    />
  );
}
